module.exports = __webpack_public_path__ + "static/mega-menu-079349d642314deaaaa5916ab98f7a5c.jpg";